import React, { useEffect, useState } from "react";
import { Text, Flex, HStack, Box, Icon, Tooltip, IconButton } from "@chakra-ui/react";

import { BsBell } from "react-icons/bs";
import { BiLogOut } from "react-icons/bi";
import DrawerMenuSidebar from "./Sidebar/DrawerMenuSidebar";
import { useNavigate } from "react-router-dom";
import LogoutModal from "./Modals/LogoutModal";

const NavBar = () => {
  const role = localStorage.getItem("role");
  const [name] = useState(localStorage.getItem("name")?.split(/(\s+)/));
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
    navigate("/");
  };

  useEffect(() => {
    if (!role) navigate("/");
  }, [navigate, role]);

  return (
    <Flex
      justifyContent="space-between"
      w="100%"
      position="sticky"
      top="0"
      p={["10px", "10px 30px"]}
      bg="white"
      borderBottom="1px solid"
      borderBottomColor="gray.100"
      align="center"
      zIndex={100}
      boxShadow="sm"
    >
      <DrawerMenuSidebar />
      <HStack spacing={6} w="100%" justify="end">
        <Tooltip label="Notifications">
          <Box position="relative" cursor="pointer" p={2} borderRadius="full" _hover={{ bg: "gray.50" }}>
            <Icon as={BsBell} color="gray.600" w={5} h={5} />
            <Box position="absolute" top="2px" right="2px" w="10px" h="10px" bg="red.500" borderRadius="full" border="2px solid white" />
          </Box>
        </Tooltip>
        
        <HStack spacing={3} pl={4} borderLeft="1px solid" borderColor="gray.100">
          <Flex
            bg="brand.500"
            color="white"
            w="38px"
            h="38px"
            borderRadius="full"
            align="center"
            justify="center"
            fontWeight="bold"
            fontSize="14px"
            boxShadow="0 2px 4px rgba(91, 46, 79, 0.2)"
            border="2px solid white"
          >
            {name?.[0]?.[0]}
            {name?.[2]?.[0]}
          </Flex>
          <Box display={["none", "block"]}>
            <Text color="gray.800" fontWeight="700" fontSize="14px" lineHeight="1">
              {localStorage.getItem("name")}
            </Text>
            <Text color="gray.500" fontWeight="500" fontSize="11px" mt={1}>
              {role}
            </Text>
          </Box>
        </HStack>
        
        <Tooltip label="Logout">
          <IconButton
            icon={<BiLogOut size={20} />}
            variant="ghost"
            colorScheme="red"
            onClick={() => setIsLogoutOpen(true)}
            borderRadius="full"
            aria-label="Logout"
          />
        </Tooltip>
      </HStack>
      <LogoutModal 
        isOpen={isLogoutOpen} 
        setIsOpen={setIsLogoutOpen} 
        onLogout={handleLogout} 
      />
    </Flex>
  );
};

export default NavBar;
